import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const occurrenceDurationStatistics: Partial<Record<keyof TComponentValue<'AlarmStatistics'>['occurrenceDurationStatistics'], string>> = {
  count: 'Počet',
  sum: 'Celková doba trvania',
  average: 'Priemerná doba trvania',
  median: 'Medián doby trvania',
};

export default {
  showAlarmWithoutOccurrences: 'Zobraziť všetky alarmy',
  occurrenceDurationStatistics,
};
